<template>
    <div class="">
        <img v-if="answer.image_url" :src="answer.image_url" :alt="answer.content" />
    </div>
</template>
<script>
export default {
    props: ['answer']
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/range-picture.vue